export const UPDATE_FILTER = 'UPDATE_FILTER';
export const updateFilter = (e) => ({
  type: UPDATE_FILTER,
  payload: e,
});

export const yearsGenerator = (year) => [
  {
    name: 'Q1',
    id: `${year}-Q1`,
    selected: true,
    children: [
      {
        name: 'Janeiro',
        id: `${year}-Q1-Janeiro`,
        selected: true,
      },
      {
        name: 'Fevereiro',
        id: `${year}-Q1-Fevereiro`,
        selected: true,
      },
      {
        name: 'Março',
        id: `${year}-Q1-Março`,
        selected: true,
      },
    ],
  },
  {
    name: 'Q2',
    id: `${year}-Q2`,
    selected: true,
    children: [
      {
        name: 'Abril',
        id: `${year}-Q2-Abril`,
        selected: true,
      },
      {
        name: 'Maio',
        id: `${year}-Q2-Maio`,
        selected: true,
      },
      {
        name: 'Junho',
        id: `${year}-Q2-Junho`,
        selected: true,
      },
    ],
  },
  {
    name: 'Q3',
    id: `${year}-Q3`,
    selected: true,
    children: [
      {
        name: 'Julho',
        id: `${year}-Q3-Julho`,
        selected: true,
      },
      {
        name: 'Agosto',
        id: `${year}-Q3-Agosto`,
        selected: true,
      },
      {
        name: 'Setembro',
        id: `${year}-Q3-Setembro`,
        selected: true,
      },
    ],
  },
  {
    name: 'Q4',
    id: `${year}-Q4`,
    selected: true,
    children: [
      {
        name: 'Outubro',
        id: `${year}-Q4-Outubro`,
        selected: true,
      },
      {
        name: 'Novembro',
        id: `${year}-Q4-Novembro`,
        selected: true,
      },
      {
        name: 'Dezembro',
        id: `${year}-Q4-Dezembro`,
        selected: true,
      },
    ],
  },
];

export const generateMoreFilters = (data) => {
  return (dispatch) => {
    if (data) {
      if (data.min && data.max) {
        const init = Number(data.min);
        const final = Number(data.max);
        const years = [];
        for (let i = init; i <= final; i++) {
          years.push(i);
        }
        const filters = {
          name: 'Todos',
          id: 'Todos',
          selected: true,
          children: years.map((el) => ({
            name: el,
            id: el.toString(),
            selected: true,
            children: yearsGenerator(el.toString()),
          })),
        };
        dispatch(updateFilter(filters));
      }
    }
  };
};

export const generateModalMoreFilters = (data) => {
  const filters = {
    name: 'Todos',
    id: 'Todos',
    selected: true,
    children: data.map((el) => ({
      name: el,
      id: el.toString(),
      selected: true,
      children: yearsGenerator(el.toString()),
    })),
  };
};
